export default __webpack_public_path__ + "static/img-about-3-27202aae2b273ca9c9494646bdae4c9c.gif";